module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j5ndv"))).then(() => parcelRequire('d0iPb'));